// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/welcome-frontend/" + {"220":"P6Bx","235":"uurv","380":"yaP1","382":"K_VX","410":"PzS-","450":"mf3M","458":"os6v"}[chunkId] + "-" + {"220":"8753a4fa7c4f","235":"4efaae360afd","380":"852a9e58d640","382":"41b9e12a9d57","410":"c6d112fc45c1","450":"3b1912df4684","458":"77962eff6aa2"}[chunkId] + ".css";
};